import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets.app/images/tutorial-night.svg'


const _hoisted_1 = { class: "tutorial__item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tutorial__image-box" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tutorial__image",
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = { class: "tutorial__text-box" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "tutorial__title" }, "Night Mode", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "tutorial__text" }, " Like a darker look when you read? Turn dark mode on here. ", -1)
const _hoisted_6 = { class: "tutorial__btn-box" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("ul", { class: "tutorial__dots" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "tutorial__dot" }),
  /*#__PURE__*/_createElementVNode("li", { class: "tutorial__dot" }),
  /*#__PURE__*/_createElementVNode("li", { class: "tutorial__dot" }),
  /*#__PURE__*/_createElementVNode("li", { class: "tutorial__dot" }),
  /*#__PURE__*/_createElementVNode("li", { class: "tutorial__dot" })
], -1)

import { computed } from 'vue'
import { BookTutorial, BookTutorialStep } from '@/models/doc.tutorial'


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarTutorialStepNight',
  props: {
    bookTutorial: null
  },
  setup(__props: any) {

const props = __props as {
  bookTutorial: BookTutorial
};



const isActive = computed(() => {
  return props.bookTutorial.step === BookTutorialStep.night
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              class: "tutorial__btn tutorial__btn--no-arr btns",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.bookTutorial.incrementStep()))
            }, "Finish")
          ]),
          _hoisted_7
        ])
      ], 512), [
        [_vShow, _unref(isActive)]
      ])
    ]),
    _: 1
  }))
}
}

})